import { ROUTE_DOCS_LANDS } from '@/common/constants';
import { ITabItem } from '@/common/models/INavbar';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useNavigate, useParams } from 'react-router-dom';
import { Badge } from '../ui/badge';
import { useTranslation } from 'react-i18next';

interface IProps {
  tab: ITabItem;
  index: number;
  isLoading?: boolean;
  tabs: ITabItem[];
}

export function NavbarItem({ tab, tabs }: IProps) {
  const navegate = useNavigate();
  const { t } = useTranslation();
  const { lang, status } = useParams();

  return (
    <Button
      variant="ghost"
      className={cn(
        'relative flex items-center border  rounded-lg py-2 px-3 gap-2 font-medium duration-300 ',
        tab?.type === status
          ? 'border-gray-300 bg-gray-100 hover:bg-gray-100 '
          : 'border-transparent hover:bg-transparent',
      )}
      onClick={() => navegate(`/${lang}/${ROUTE_DOCS_LANDS}/${tab?.type}`)}
    >
      <span
        className={cn(
          'whitespace-nowrap text-sm',
          tab ? 'text-black' : 'text-gray-900',
        )}
      >
        {t(tab.name)}
      </span>
      <Badge>{tabs?.find((item) => item.type === tab.type)?.count || 0}</Badge>
    </Button>
  );
}
